<template>
    <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M17 7.875V10.125H2L2 7.875L17 7.875Z" fill="#48E4FF" />
        <path
            d="M10.625 16.5H8.375L8.375 1.5L10.625 1.5L10.625 16.5Z"
            fill="#48E4FF"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
